// Wirtualny joystick (lewa połowa ekranu, pojawia się tam, gdzie dotknie kciuk) + obsługa klawiatury na desktopie.
import { h, ui } from './dom.js';

export class Joystick {
  dx = 0;
  dy = 0;
  private id: number | null = null;
  private ox = 0;
  private oy = 0;
  private base = h('div', { class: 'stick-base' });
  private knob = h('div', { class: 'stick-knob' });
  private zone = h('div', { class: 'stick-zone' });
  private keys = new Set<string>();
  private readonly R = 56;

  constructor() {
    this.base.append(this.knob);
    this.zone.append(this.base);
    ui().append(this.zone);
    this.zone.addEventListener('pointerdown', (e) => {
      if (this.id !== null) return;
      this.id = e.pointerId;
      this.zone.setPointerCapture(e.pointerId);
      this.ox = e.clientX; this.oy = e.clientY;
      this.base.style.left = `${e.clientX}px`; this.base.style.top = `${e.clientY}px`;
      this.base.classList.add('on');
      this.move(e.clientX, e.clientY);
    });
    this.zone.addEventListener('pointermove', (e) => { if (e.pointerId === this.id) this.move(e.clientX, e.clientY); });
    const end = (e: PointerEvent) => {
      if (e.pointerId !== this.id) return;
      this.id = null; this.dx = this.dy = 0;
      this.base.classList.remove('on'); this.knob.style.transform = '';
    };
    this.zone.addEventListener('pointerup', end);
    this.zone.addEventListener('pointercancel', end);
    window.addEventListener('keydown', (e) => { if (!(e.target instanceof HTMLInputElement)) this.keys.add(e.code); });
    window.addEventListener('keyup', (e) => this.keys.delete(e.code));
    window.addEventListener('blur', () => this.keys.clear());
  }

  private move(x: number, y: number): void {
    let vx = x - this.ox, vy = y - this.oy;
    const len = Math.hypot(vx, vy);
    if (len > this.R) { vx = vx / len * this.R; vy = vy / len * this.R; }
    this.knob.style.transform = `translate(${vx}px, ${vy}px)`;
    const dead = 10;
    this.dx = len < dead ? 0 : vx / this.R;
    this.dy = len < dead ? 0 : vy / this.R;
  }

  /** Kierunek na ekranie (−1..1). Klawiatura ma pierwszeństwo, gdy wciśnięta. */
  direction(): [number, number] {
    const k = this.keys;
    const kx = (k.has('KeyD') || k.has('ArrowRight') ? 1 : 0) - (k.has('KeyA') || k.has('ArrowLeft') ? 1 : 0);
    const ky = (k.has('KeyS') || k.has('ArrowDown') ? 1 : 0) - (k.has('KeyW') || k.has('ArrowUp') ? 1 : 0);
    return kx || ky ? [kx, ky] : [this.dx, this.dy];
  }
}
